import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Autocomplete, Button } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';
import MyCurrentLocation from './MyCurrentLocation/MyCurrentLocation.js';

const StoreSearchForm = (_param)=>{
    var { className , labels , loading , showClearButton , searchQuery , suggestions , searchRef , onChange , onSubmit , onClear , onSuggestionClick , onUseMyCurrentLocationClick , isFocusedOnMount , isSuggestionSelected , isUsingUserLocation , minSearchCharacterCount , onSuggestionTopContentClick , queryResultsFilters  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "loading",
        "showClearButton",
        "searchQuery",
        "suggestions",
        "searchRef",
        "onChange",
        "onSubmit",
        "onClear",
        "onSuggestionClick",
        "onUseMyCurrentLocationClick",
        "isFocusedOnMount",
        "isSuggestionSelected",
        "isUsingUserLocation",
        "minSearchCharacterCount",
        "onSuggestionTopContentClick",
        "queryResultsFilters"
    ]);
    const autoCompleteLabels = React.useMemo(()=>({
            placeholder: labels.placeholder,
            noResults: labels.noResults,
            noAvailableResultsScreenReaderHint: labels.noAvailableResultsScreenReaderHint
        })
    , [
        labels
    ]);
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-search-field-stores-v2', className)
    }), /*#__PURE__*/ React.createElement("div", {
        className: "store-search-field-stores-v2__search-form"
    }, /*#__PURE__*/ React.createElement("form", {
        role: "search",
        action: "",
        onSubmit: (event)=>{
            console.log('Submit was prevented');
            event && event.preventDefault();
            onSubmit();
        }
    }, /*#__PURE__*/ React.createElement(Autocomplete, {
        className: classnames({
            'store-search-field-stores-v2__search-form--with-user--location': isUsingUserLocation
        }),
        inputRef: searchRef,
        name: "store-search",
        type: "search",
        labels: autoCompleteLabels,
        isFocusedOnMount: isFocusedOnMount,
        loading: loading,
        value: searchQuery,
        showClearButton: showClearButton,
        submitIcon: /*#__PURE__*/ React.createElement(Icon, {
            name: "search"
        }),
        minCountCharactersToSubmit: minSearchCharacterCount,
        isSuggestionSelected: isSuggestionSelected,
        suggestionTopContent: !isUsingUserLocation ? /*#__PURE__*/ React.createElement(MyCurrentLocation, {
            label: labels.useMyCurrentLocation
        }) : undefined,
        suggestions: suggestions,
        inputDataT: "search",
        onChange: onChange,
        onSubmit: onSubmit,
        onClear: onClear,
        onSuggestionClick: onSuggestionClick,
        onSuggestionTopContentClick: onSuggestionTopContentClick,
        disabled: isUsingUserLocation
    })), !isUsingUserLocation && /*#__PURE__*/ React.createElement(Button, {
        variant: "outline",
        icon: "gps",
        caption: labels.useMyCurrentLocation,
        className: "store-search-field-stores-v2__button",
        onClick: onUseMyCurrentLocationClick,
        "data-t": "userLocationBtn"
    })), queryResultsFilters ? /*#__PURE__*/ React.createElement("div", {
        className: "store-search-field-stores-v2__query-results-filters"
    }, queryResultsFilters) : null);
};

export { StoreSearchForm as default };
//# sourceMappingURL=StoreSearchForm.js.map
